import { useId } from 'react';
import { useSelector } from 'react-redux';
import { useRealtimeResource, useRealtimeState } from '../../realtime/RealtimeProvider';
import { selectApiUrls } from '../../redux/slices/apiUrlSlice';
import { SOLD_TO_SHIP_TO_CHANGED } from '../../config/liveUpdateEvents';
import useLiveUpdates from '../../hooks/useLiveUpdates';

export const SHIPPING_CHANGED = 'shipping/display-changed';
export const isShippingNotification = (action, scope) => action?.type === SHIPPING_CHANGED
  && action.payload?.version === 1 && action.payload.scope === scope
  && Number.isSafeInteger(action.payload.projectId) && action.payload.projectId > 0
  && typeof action.payload.clientId === 'string' && typeof action.payload.id === 'string';

export default function useShippingLiveUpdates({ enabled, scope, blocked, refresh }) {
  const urls = useSelector(selectApiUrls);
  const owner = useId();
  const { mode } = useRealtimeState();
  useRealtimeResource({ enabled: enabled && ['session', 'domain'].includes(mode), ownerKey: `shipping:${owner}:${scope}`,
    resources: ['portal:shipping', 'portal:full-schedule', 'portal:general-project-info', 'portal:assembly-schedule',
      'portal:soldto-shipto-info', 'portal:price-breakdown-info'], blocked, refresh });
  const live = useLiveUpdates({ enabled: enabled && !['session', 'domain'].includes(mode), type: SHIPPING_CHANGED, scope, blocked, refresh,
    matches: (action) => (action?.type === SHIPPING_CHANGED && action.payload?.scope === scope)
      || (Boolean(urls.soldToShipTo) && action?.type === SOLD_TO_SHIP_TO_CHANGED && action.payload?.scope === urls.soldToShipTo),
    validate: (action) => Number.isSafeInteger(action.payload.projectId) && action.payload.projectId > 0 });
  return { ...live, publish: (projectId) => ['session', 'domain'].includes(mode) ? Promise.resolve('backend-managed')
    : live.publish({ projectId: Number(projectId) }) };
}
